import { Col, Row, Divider } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import TagComponent from "../../../biblio/TagComponent";
interface InfoProps {
  infoArray: any;
}
const SchoolInfoContent = ({ infoArray }: InfoProps) => {
  const { t } = useTranslation();
  return (
    <>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الإسم</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p> الهاتف الأول </p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.mobile}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>الجنس</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{t(`gender.${infoArray?.gender}`)}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p> البريد الالكتروني</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.email}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p> المستويات الدراسية</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          {infoArray?.academic_level_ids?.map((item: any) => (
            <TagComponent
              className="takaful--tag-style"
              state={infoArray?.id}
              text={item.name}
            />
          ))}
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p>العنوان </p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.street}</span>
        </Col>
      </Row>

      <Divider className="takaful--service-section-divider" />

      <Row className="takaful--content-profile-box1">
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <div className="takaful--content-profile-title">
            <h1> بيانات ممثل المدرسة</h1>
          </div>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>اسم الممثل </p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <span>{infoArray?.representative_name}</span>
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}>
          <p> هاتف الممثل</p>
        </Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
          <span>{infoArray?.acc_number}</span>
        </Col>
      </Row>
      <Row justify={"space-between"} className="takaful--content-profile-box1">
        <Col
          xxl={5}
          xl={5}
          lg={5}
          md={5}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          <p>البريد الالكتروني للممثل</p>
        </Col>
        <Col
          xxl={6}
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
          className="takaful--content-profile-col"
        >
          {Array.isArray(infoArray?.bank_id) &&
            infoArray?.bank_id.length > 1 && (
              <span>{infoArray?.bank_id[1]}</span>
            )}
        </Col>

        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>

        <Col xxl={5} xl={5} lg={5} md={5} sm={12} xs={12}></Col>
        <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}></Col>
      </Row>
    </>
  );
};

export default SchoolInfoContent;
